import { render, staticRenderFns } from "./ListMenuV1Collapse.vue?vue&type=template&id=51ae0a0e&scoped=true"
import script from "./ListMenuV1Collapse.vue?vue&type=script&lang=js"
export * from "./ListMenuV1Collapse.vue?vue&type=script&lang=js"
import style0 from "./ListMenuV1Collapse.vue?vue&type=style&index=0&id=51ae0a0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae0a0e",
  null
  
)

export default component.exports